import { useEffect } from "react";
import { findParentByClass } from "@similarweb/ui-components";

function useDeactivateOnOutsideClick(containerClassName: string, isActive: boolean, onOutsideClick: () => void) {
    useEffect(() => {
        function handleBodyClick(e: Event) {
            const parent = findParentByClass(e.target as Element, containerClassName);

            if (!parent) {
                onOutsideClick();
            }
        }

        if (isActive) {
            setTimeout(() => {
                document.addEventListener("click", handleBodyClick, true);
            });
        } else {
            document.removeEventListener("click", handleBodyClick, true);
        }

        return () => {
            document.removeEventListener("click", handleBodyClick, true);
        };
    }, [isActive]);
}

export default useDeactivateOnOutsideClick;
